(() => {
  const sectionIdsList = [
    "price",
    "price-history",
    "what-if",
    "growth-table",
    "convert",
    "popular",
    "prices",
    "how-to",
    "crypto-trends",
    "what-can-you-do",
    "popular-faq",
    "other-cryptos",
    "learn",
    "resources",
    "reviews",
  ];
  let lastActiveId = "";
  const visibleSections = new Set();

  const clearActiveLink = () => {
    document.querySelectorAll(".navigation-wrapper__item").forEach((el) => {
      el.classList.remove("active");
    });
    lastActiveId = "";
  };

  const setActiveLink = (id) => {
    if (id !== lastActiveId) {
      clearActiveLink();
      lastActiveId = id;
      const activeLink = document.getElementById(`${id}-nav`);
      if (activeLink) {
        activeLink.classList.add("active");
      }
    }
  };

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.2,
  };

  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      const id = entry.target.id;

      if (entry.isIntersecting) {
        visibleSections.add(id);
        setActiveLink(id);
        break;
      } else {
        visibleSections.delete(id);  
      }
    }

    if (visibleSections.size === 0) {
      clearActiveLink();
      return;
    }
  }, observerOptions);

  sectionIdsList.forEach((id) => {
    const section = document.getElementById(id);
    if (section) {
      observer.observe(section);
    }
  });
})();
